
<mat-form-field class="full-width-field chips" appearance="outline">
    <mat-chip-list #chipList>
        <mat-chip
            *ngFor="let item of selected_items;let indx=index;"
            [selectable]    =   "selectable"
            [removable]     =   "removable"
            (removed)       =   "remove(item,indx)">
            
            {{ item[display_chips] }}
            
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input #statusInput
               [formControl]                    =   "itemCtrl"
               [matAutocomplete]                =   "auto"
               [matChipInputFor]                =   "chipList"
               [matChipInputSeparatorKeyCodes]  =   "separatorKeysCodes"
               [matChipInputAddOnBlur]          =   "addOnBlur"
               (matChipInputTokenEnd)           =   "add($event)"
        >
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let item of filtered_items | async" [value]="item">
            
            <span [innerHTML]="item[display]"></span>
            
        </mat-option>
    </mat-autocomplete>
    
</mat-form-field>